<template>
  <div class="page">
    <div class="current-date">本月</div>
    <div class="list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="onLoad"
      >
        <div class="list-item pi-flex pi-divider pi-center-items" v-for="(item, index) in list" :key="index">
          <div class="pi-flex-item padding-left-normal">
            <div class="text-size-32 text-color-second">{{item.transactionTypeDesc}}</div>
            <div class="text-size-24 text-color-third margin-top-normal">{{item.creationTime}}</div>
          </div>
          <div>
            <div class="text-size-28 text-color-first">{{item.amount}}</div>
          </div>
          <img style="width: 0.3rem; height: 0.3rem; margin-left: 0.2rem" src="../../assets/img/icon-right.png"
               alt="">
        </div>
      </van-list>
    </div>
    <div class="bottom-action-container">
      <span style="border-right: #999999 1px solid" @click="showFilterPanel = true" >查询其他日期</span>
      <span @click="showFilterPanel = true">筛选</span>
    </div>
    <filter-view v-model="showFilterPanel" v-bind:filterData="filterData" v-on:onConfirm="onConfirm"></filter-view>
  </div>
</template>

<script>
import { getTransactionList } from '@/common/api/index';
import FilterView from './fitler-view';
import { List } from 'vant';
import { getCurrentMonthFirstDate } from '@/common/old/public/date-format';
export default {
  name: 'money-detail',
  components: {
    [FilterView.name]: FilterView,
    [List.name]: List
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      pageIndex: 0,
      pageSize: 10,
      periodType: null,
      transactionType: null,
      showFilterPanel: false,
      filterData: {
        endTime: new Date(),
        startTime: getCurrentMonthFirstDate()
      }
    };
  },
  mounted() {
    console.log('startTime:' + this.startTime);
    console.log('endTime:' + this.endTime);
    this.getList();
  },
  methods: {
    onConfirm(filterData) {
      this.filterData = filterData;
      this.refresh();
    },
    refresh() {
      this.pageIndex = 0;
      this.list = [];
      this.loading = true;
      this.onLoad();
    },
    onLoad() {
      this.getList();
    },
    gotoTargetRoute(name) {
      this.$router.push(name);
    },
    getList() {
      getTransactionList({
        accountPkId: this.$testPkId,
        endTime: this.formatDate(this.filterData.endTime),
        globalPageIndex: this.pageIndex + 1,
        globalPageSize: this.pageSize,
        periodType: this.filterData.timeTypes,
        startTime: this.formatDate(this.filterData.startTime),
        transactionType: this.filterData.queryTypes
      }).then((data) => {
        if (data.status === 0 && data.data) {
          if (this.pageIndex === 0) {
            this.list = [];
          }
          this.pageIndex++;
          for (let i = 0; i < data.data.length; i++) {
            this.list.push(data.data[i]);
          }

          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (this.pageIndex >= data.totalPage) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        }
      }).catch((error) => {
        console.log(error);
        this.loading = false;
        this.finished = true;
      });
    },
    formatDate (value) {
      if (value) {
        return value.getFullYear() + '-' + this.addZero(value.getMonth() + 1) + '-' + this.addZero(value.getDate());
      }
      return null;
    },
    addZero(num) {
      return num > 9 ? num : '0' + num;
    }
  }
};
</script>

<style lang="less" scoped>
  .page {
    display: flex;
    height: 100%;
    flex-direction: column;
    .current-date {
      background-color: #14CC80;
      font-size: 0.32rem;
      padding: 0.21rem 0.2rem;
      color: white;
    }
    .list {
      overflow-y: scroll;
      .list-item {
        margin: 0 0.2rem;
        padding: 0.2rem 0;
      }
    }
    .bottom-action-container{
      margin: 0.2rem 0 0.2rem 0;
      text-align: center;
      span {
        color: #48607D;
        font-size: 0.28rem;
        padding: 0 0.2rem;
      }
    }
  }
</style>
